import queryString from "qs"
import { tabIndexOrder } from "./config";

export type SearchStateType = {
    query?: string;
    indices?: {
        [index: string]: {
          page?: number;
        };
    }
}

export type QueryStringObjectType = {
    query?: string;
    page?: string;
    index?: string;
}

// Converts query string to object.
export const parseQS = (): QueryStringObjectType => {
    if(typeof window !== "undefined") {
        return queryString.parse((window?.location?.search.substr(1)));
    }
    return {};
}

export const urlToSearchState = () => qsObjectToSearchState(parseQS());

// Add search state and new QS params to browser history
export const pushSearchHistory = (updatedSearchState: SearchStateType, currentIndexName: string) => {
    if(typeof window !== "undefined") {
        window.history.pushState(updatedSearchState, '', createURL(searchStateToQSObject(updatedSearchState, currentIndexName)));
    }
}

// Returns query string filled URL of search. Inspiration taken from 
export const createURL = (qsObject: QueryStringObjectType) => {
    if (typeof window !== "undefined") {
        const qs = queryString.stringify(qsObject, {
            encode: false,
            addQueryPrefix: true,
            arrayFormat: 'repeat',
        });
        return `${window.location.pathname}${qs}`;
    }
    return ''
}

// Converts Algolia search state type to our qs formatted object
const searchStateToQSObject = (state: SearchStateType, currentIndex: string): QueryStringObjectType => {
    let result: QueryStringObjectType = {};

    if (state?.query){
        result.query = state?.query;
    }

    // Get the index config for the currently selected tab
    const currentIndexConfigIndex = tabIndexOrder.findIndex(tab => tab.indexName == currentIndex);

    // Set corresponding "index" param with index's tabname and page
    if(currentIndexConfigIndex !== -1){
        result.index = tabIndexOrder[currentIndexConfigIndex].tabName;

        const currentIndexState = state?.indices?.[currentIndex]
        // set the page param if the data is available in search state
        if (currentIndexState){
            result.page = currentIndexState?.page?.toString();
        }
    }

    return result;
}

// Convert our qs format to Algolia's expected search state
export const qsObjectToSearchState = (qs: QueryStringObjectType): SearchStateType => {
    let result: SearchStateType = {};

    if (qs?.query){
        result.query = qs?.query;
    }

    if (qs?.index) {
        result.indices = {};
        // Get index config based on tab name from index parameter
        const indexConfigIndex = tabIndexOrder.findIndex(tab => tab.tabName == qs?.index);
        if(indexConfigIndex !== -1) {
            result.indices[tabIndexOrder[indexConfigIndex].indexName] = {
                page: qs?.page ? parseInt(qs?.page) : 1
            };
        }
    }
    return result;
}